import React, { useState } from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Button, Table, Row, Col, Form } from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import Pagination from 'react-js-pagination';
import { DebounceInput } from 'react-debounce-input';
import ActionAttachingModal from 'components/S3Explorer/ActionAttachingModal';
import Can from "components/Can";
import { formatDate, parseDate, parseDateBR } from 'helpers/date';
import ModalHistoric from 'components/ListingInvoiceApproval/ModalHistoric';
import { api } from 'services';

function ListingFilesDataBase({
  files,
  setFiles,
  filters,
  stateFilters,
  setFilters,
  handleFilterChange,
  attachingModal,
  status,
  setStatus,
  pagination
}) {
  const location = useLocation();
  const { pathname } = location;
  const { t } = useTranslation();

  const [data, setData] = useState(null);
  const [show, setShow] = useState(false);

  const handlePageChange = (page) => handleFilterChange({ page });

  const getStatus = (statusParam) => {
    let teste = '';
    if (statusParam === 8) {
      teste += t('statuses:approved_nf');
    } else if (statusParam === 6) {
      teste += t('statuses:on_approval_nf');
    } else if (statusParam === 7) {
      teste += t('statuses:disapproved_nf');
    }
    return teste;
  };

  const getCurrency = (currency, value) => {
    switch (currency?currency.toString():'') {
      case '1':
        return value.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
      case '2':
        return value.toLocaleString('pt-BR',{style:'currency',currency:'USD'});
      case '3':
        return value.toLocaleString('pt-BR',{style:'currency',currency:'EUR'});
      default:
        return value.toLocaleString('pt-BR',{style:'currency',currency:'BRL'});
        break;
    }
  };

  const getModel = (type,id) => {
    setShow(true);
    if(type == "Evento"){
      api.get('event-expense-descriptions/'+id).then(({data})=>{
        setData(data);
      });
    } else {
      api.get('expense-descriptions/'+id).then(({data})=>{
        setData(data);
      });
    }
  }

  const getInfo = async (type,id) => {
    if(type == "Evento"){
      let response = await api.get('event-expense-descriptions/'+id);
      return response.data;
    } else {
      let response = await api.get('expense-descriptions/'+id);
      return response.data;
    }
  }

  return (
    <>
      <ModalHistoric data={data} show={show} handleHideModalAUX={()=>{
        setShow(false);
        setData(null);
      }}/>
      <Row>
        <Col>
          {pathname.includes('files') ? (
            <Row>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>{t('label:records per page')}:</Form.Label>
                  <Form.Control
                    as="select"
                    value={stateFilters.per_page}
                    onChange={(e) =>
                      handleFilterChange({ per_page: e.target.value, page:1 })
                    }
                  >
                    <option value={10}>10</option>
                    <option value={25}>25</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Form.Control>
                </Form.Group>
              </Col>
              <Col md={3} className="ml-auto">
                <Form.Group>
                  <Form.Label>{t('label:search')}:</Form.Label>
                  <DebounceInput
                    element={Form.Control}
                    debounceTimeout={500}
                    value={stateFilters.__search}
                    onChange={(e) =>
                      handleFilterChange({ __search: e.target.value, page:1 })
                    }
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : (
            ''
          )}
          <Table hover bordered responsive>
            <thead>
              <tr>
                {/* <td className="text-center align-middle">
                  {t('label:status')}
                </td> */}
                <th className="text-center align-middle">Número NF</th>
                <th className="text-center align-middle">Razão Social</th>
                <th className="text-center align-middle">Valor</th>
                <th className="text-center align-middle">Vencimento</th>
                <th className="text-center align-middle">Data Emissão</th>
                <th className="text-center align-middle">Projeto</th>
                <th className="text-center align-middle">Tipo</th>
                <th className="text-center align-middle">Status</th>
                <th className="text-center align-middle">{t('label:actions')}</th>
              </tr>
            </thead>
            <tbody>
              {files.map((file, k) => {
                if(!pathname.includes('files') && file.type=='Evento') return '';
                return (
                <tr key={k}>
                  {/* <td className="text-center align-middle">
                    {getStatus(file.expense_description.status_id)}

                    invoice_number, service_provider, value, due_date, type, issuance_date, project, currency

                  </td> */}
                  <td className="text-center align-middle">{file.invoice_number}</td>
                  <td className="text-center align-middle">{file.service_provider}</td>
                  <td className="text-center align-middle">{getCurrency(file.currency,file.value)}</td>
                  <td className="text-center align-middle">{file.due_date?parseDateBR(file.due_date):'---'}</td>
                  <td className="text-center align-middle">{file.issuance_date?parseDateBR(file.issuance_date):'---'}</td>
                  <td className="text-center align-middle">{file.project}</td>
                  <td className="text-center align-middle">{file.type}</td>
                  <td className="text-center align-middle">{getStatus(file.status_id_db)}</td>
                  {pathname.includes('files') ? (
                    
                    <td className="text-center align-middle">
                      <Button
                        variant="light"
                        alt={t('label:nf preview')}
                        size="sm"
                        target="_blank"
                        title={t('label:nf preview')}
                        onClick={()=>getModel(file.type,file.id)}
                      >
                        <i className="fas fa-eye" />
                      </Button>
                      &nbsp;
                      {/* {file.type=='action'?(
                      <Can do="attachFiles" on="App">
                        <ActionAttachingModal
                          onClick={attachingModal}
                          fileId={file.id}
                        />
                      </Can>
                      ):''} */}
                      {file.type.indexOf('Avulsa')!=-1 && file.status_id_db == 7?(
                      <Can do="createExpenseDescription" on="App">
                        <Button
                          href={'/files/edit/'+file.id}
                          variant="light"
                          alt={t('label:nf preview')}
                          size="sm"
                          title={t('label:nf preview')}
                        >
                        <i className="fas fa-pen" />
                      </Button>
                      </Can>
                      ):''}
                    </td>
                  ) : (
                    <td>
                      <Button
                        // href={file.uri}
                        variant="light"
                        alt={t('label:nf preview')}
                        size="sm"
                        target="_blank"
                        title={t('label:nf preview')}
                        onClick={()=>getModel(file.type,file.id)}
                      >
                        <i className="fas fa-eye" />
                      </Button>
                      &nbsp;
                      <Button
                        variant="light"
                        alt={t('label:link')}
                        size="sm"
                        title={t('label:link')}
                        onClick={async () => {
                          setFiles(await getInfo(file.type,file.id))
                        }}
                        disabled={file.type=='Evento' || file.status_id_db!=8}
                      >
                        <i className="fas fa-link" />
                      </Button>
                    </td>
                  )}
                </tr>
              )})}
              {files && files.length > 0?'':(
                <tr>
                  <td colSpan="9">{t('phrase:invoice')}</td>
                </tr>
              )}
            </tbody>
          </Table>
          {pathname.includes('files') ? (
            <Row>
              <Col>
              {pagination?(
                <Trans i18nKey="label:interpolateShowingRecords">
                  Showing {{ from: pagination.from || '0' }} to{' '}
                  {{ to: pagination.to || '0' }} from {{ total: pagination.total }}{' '}
                  records
                </Trans>
              ):''}
              </Col>
              <Col className="d-flex justify-content-end">
                {pagination?(
                  <Pagination
                    activePage={pagination.current_page}
                    itemsCountPerPage={pagination.per_page}
                    totalItemsCount={pagination.total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    itemClass="page-item"
                    linkClass="page-link"
                    prevPageText="‹"
                    nextPageText="›"
                  />
                ):''}
              </Col>
            </Row>
          ) : (
            ''
          )}
        </Col>
      </Row>
    </>
  );
}
export default ListingFilesDataBase;
